import { optionTitle_schedulingPermissions } from './ResourceScheduling.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { ALLOWED_OPTION_KEYS } from './ResourceSchedulingConstants';
import { isFeatureEnabled } from 'owa-feature-flags';

const lazyFullModule = new LazyModule(() => import('./lazySchedulingPermissionsFullOption'));
const ResourceSchedulingPermissions: LazyOption = createLazyOption(
    {
        key: 'resourceSchedulingPermissions',
        titleStringKey: optionTitle_schedulingPermissions,
        searchTermsStringKey: optionTitle_schedulingPermissions,
        isHidden: () => {
            return !isFeatureEnabled('cal-mf-resourceSchedulingSetting');
        },
        allowedOptionKeys: ALLOWED_OPTION_KEYS,
    },
    lazyFullModule,
    m => m.default
);
export default ResourceSchedulingPermissions;
